// Only an explicit absence permits replaying a POST. An outage or an active
// run must keep polling so retries cannot duplicate expensive generation.
function retryRecoveryAction(data) {
  if (data && data.status === "ready") return "render";
  if (data && data.status === "none") return "rerun";
  return "poll";
}
module.exports = { retryRecoveryAction };
